import React from 'react';
import { useSelector } from 'react-redux';
import { selectYandexPayData } from 'src/store/payment/selectors';
import styles from './YandexPay.module.css';
import {
  useLazyYandexPaySdk,
  YANDEX_PAY_BUTTON_SELECTOR,
} from './useLazyYandexPaySdk';
import Agreement from '../../../Agreement/AgreeBlock';

const YandexPay = () => {
  const yandexData = useSelector(selectYandexPayData);
  useLazyYandexPaySdk();

  if (!yandexData || !yandexData.availablePaymentMethods.includes('CARD'))
    return null;

  return (
    <div className={styles.agreement}>
      <Agreement />
      <div
        id={YANDEX_PAY_BUTTON_SELECTOR}
        className={styles.yandexPayContainer}
      />
    </div>
  );
};

export default YandexPay;
